/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

:host {
  display: block;
  outline: 2px solid transparent;
  outline-offset: 2px;
  margin-inline-start: 0px;
}

:host([layout=inline]) {
  flex: 0 1 auto;
}

:host([layout=center]) {
  flex: 1 1 auto;
}

.content {
  position: relative;
  margin-block-end: 0.125rem;
  box-sizing: border-box;
  display: flex;
  block-size: 100%;
  align-items: center;
  justify-content: center;
}

.scale-s .content {
  padding-block: 0.25rem;
  font-size: var(--calcite-font-size--2);
  line-height: 1rem;
}
.scale-s .close-button {
  inline-size: 1.25rem;
}

.scale-m .content {
  padding-block: 0.5rem;
  font-size: var(--calcite-font-size--1);
  line-height: 1rem;
}
.scale-m .close-button {
  inline-size: 1.75rem;
}

.scale-l .content {
  padding-block: 0.625rem;
  font-size: var(--calcite-font-size-0);
  line-height: 1.25rem;
}
.scale-l .close-button {
  inline-size: 2rem;
}

:host([closable]) .content {
  border-block-end-color: transparent;
}

:host([layout=inline]) .content,
:host([layout=center]) .content {
  padding-inline: 0.25rem;
}

:host([layout=center]) .scale-s,
:host([layout=center]) .scale-m,
:host([layout=center]) .scale-l {
  margin-block: 0px;
  justify-content: center;
  text-align: center;
}
:host([layout=center]) .scale-s .content,
:host([layout=center]) .scale-m .content,
:host([layout=center]) .scale-l .content {
  flex: 1 1 auto;
  flex-grow: 1;
}

.container {
  position: relative;
  box-sizing: border-box;
  display: flex;
  block-size: 100%;
  inline-size: 100%;
  cursor: pointer;
  align-content: center;
  justify-content: space-between;
  padding-inline: 0px;
  font-size: var(--calcite-font-size--1);
  line-height: 1rem;
  color: var(--calcite-color-text-3);
  outline-color: transparent;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
}

.selected-indicator {
  position: absolute;
  display: block;
  block-size: 0.125rem;
  inline-size: 100%;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
  inset-block-end: 0;
  inset-inline-start: 0;
  inset-inline-end: 0;
  inline-size: 100%;
}

.container--bottom .selected-indicator {
  inset-block-end: unset;
  inset-block-start: 0;
}

:host([bordered]) .selected-indicator {
  inset-block-start: 0;
  inset-block-end: unset;
  inset-inline-start: -1px;
  inset-inline-end: 0;
  inline-size: calc(100% + var(--calcite-spacing-base));
}

:host([bordered]) .container:not(.container--bottom) {
  border-block-end: 1px solid transparent;
}

:host([bordered]:not([selected]):hover) .container:not(.container--bottom) {
  border-block-end: 1px solid var(--calcite-color-border-1);
}

:host([bordered]:not([selected]):hover:not(:focus)) .selected-indicator {
  background-color: var(--calcite-color-foreground-2);
}
:host([bordered]:not([selected]):hover:not(:focus)) .container:not(.container--bottom) .selected-indicator {
  box-shadow: inset 0 1px var(--calcite-color-border-1);
}
:host([bordered]:not([selected]):hover:not(:focus)) .container.container--bottom .selected-indicator {
  box-shadow: inset 0 -1px var(--calcite-color-border-1);
}

:host([bordered][selected]) .container::after {
  position: absolute;
  display: block;
  block-size: 0.125rem;
  inline-size: 100%;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
  inset-block-end: -1px;
  inset-inline-start: 0;
  inset-inline-end: 0;
  inline-size: 100%;
  background: var(--calcite-color-foreground-1);
  content: "";
}

:host([bordered][selected]) .container.container--bottom::after {
  inset-block-start: -1px;
}

:host([bordered][selected]:hover) .container::after {
  background: var(--calcite-color-foreground-2);
}

:host([bordered][selected]:focus) .container::after {
  background: transparent;
}

:host([bordered]) .container--bottom .selected-indicator {
  inset-block-start: unset;
  inset-block-end: 0;
}

:host([selected]) .selected-indicator,
:host([selected]:hover) .selected-indicator {
  background-color: var(--calcite-color-brand);
}

:host(:hover) .selected-indicator {
  background-color: var(--calcite-color-border-3);
}

:host(:focus) .selected-indicator,
:host(:active) .selected-indicator {
  background-color: var(--calcite-color-brand);
}

@media (forced-colors: active) {
  .selected-indicator {
    background-color: highlight;
  }
}
:host([closed]) {
  display: none;
}

:host([selected]) .container {
  border-color: transparent;
  color: var(--calcite-color-text-1);
}

:host(:focus) .container {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}
:host(:focus) .container:focus-within {
  outline-color: transparent;
}

:host(:active) a,
:host(:focus) a,
:host(:hover) a {
  border-color: var(--calcite-color-border-2);
  color: var(--calcite-color-text-1);
  text-decoration-line: none;
}

:host([disabled]) .container {
  pointer-events: none;
  opacity: 0.5;
}
:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

.calcite-tab-title--icon {
  position: relative;
  margin: 0px;
  display: inline-flex;
  align-self: center;
}
.calcite-tab-title--icon svg {
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
}

.content--has-text {
  padding: 0.25rem;
}

.content--has-text .calcite-tab-title--icon.icon-start {
  margin-inline-end: var(--calcite-spacing-sm);
}

.content--has-text .calcite-tab-title--icon.icon-end {
  margin-inline-start: var(--calcite-spacing-sm);
}

.close-button {
  display: flex;
  block-size: 100%;
  cursor: pointer;
  appearance: none;
  align-content: center;
  align-items: center;
  justify-content: center;
  align-self: center;
  border-style: none;
  background-color: transparent;
  color: var(--calcite-color-text-3);
  outline-color: transparent;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
  margin-inline-start: var(--calcite-spacing-sm);
  margin-inline-end: var(--calcite-spacing-px);
  block-size: calc(100% - var(--calcite-spacing-xxs));
}
.close-button:focus {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
}
.close-button:focus, .close-button:hover {
  color: var(--calcite-color-text-1);
  background-color: var(--calcite-color-foreground-3);
}
.close-button:active {
  color: var(--calcite-color-text-1);
  background-color: var(--calcite-color-foreground-3);
}
.close-button calcite-icon {
  color: inherit;
}

:host([icon-start][icon-end]) .calcite-tab-title--icon:first-child {
  margin-inline-end: var(--calcite-spacing-sm);
}

:host([bordered]) .container:not(.container--bottom) .close-button {
  block-size: calc(100% - var(--calcite-spacing-px));
  margin-block-start: -1px;
}
:host([bordered]) .container .close-button calcite-icon {
  margin-block-start: var(--calcite-spacing-px);
}
:host([bordered]) .container .close-button:focus, :host([bordered]) .container .close-button:hover, :host([bordered]) .container .close-button:active {
  box-shadow: 0 2px 0 0 var(--calcite-color-foreground-3);
}
:host([bordered]) .container.container--bottom .close-button {
  box-shadow: 0 -2px 0 0 transparent;
}
:host([bordered]) .container.container--bottom .close-button calcite-icon {
  margin-block-end: var(--calcite-spacing-px);
}
:host([bordered]) .container.container--bottom .close-button:focus, :host([bordered]) .container.container--bottom .close-button:hover, :host([bordered]) .container.container--bottom .close-button:active {
  box-shadow: 0 -2px 0 0 var(--calcite-color-foreground-3);
}

:host([bordered][selected]) {
  box-shadow: inset 0 -1px var(--calcite-color-foreground-1);
}

:host([bordered]:not([selected])) .container .close-button {
  box-shadow: 0 2px 0 0 transparent;
}

:host([bordered]:hover) .container {
  background-color: var(--calcite-color-foreground-2);
}

:host([bordered]) .container {
  border-inline: var(--calcite-spacing-px) solid transparent;
}

:host([selected][bordered]) .container {
  border-inline-color: var(--calcite-color-border-1);
}

:host([layout=inline][bordered]) .scale-m .content,
:host([layout=center][bordered]) .scale-m .content {
  padding-inline: 0.75rem;
}
:host([layout=inline][bordered]) .scale-s .content,
:host([layout=center][bordered]) .scale-s .content {
  padding-inline: 0.5rem;
}
:host([layout=inline][bordered]) .scale-l .content,
:host([layout=center][bordered]) .scale-l .content {
  padding-inline: 1rem;
}

:host([layout=inline][closable]) .scale-s .content,
:host([layout=inline][closable]) .scale-m .content,
:host([layout=inline][closable]) .scale-l .content {
  padding-inline-end: 0;
}

@media (forced-colors: active) {
  :host {
    outline-width: 0;
    outline-offset: 0;
  }
  :host(:focus) .container {
    outline-color: highlight;
  }
  :host([bordered]) .container {
    border-block-end-style: solid;
  }
  :host([bordered]) .container--bottom {
    border-block-start-style: solid;
  }
  :host([bordered][selected]) .container {
    border-block-end-style: none;
  }
  :host([bordered][selected]) .container--bottom {
    border-block-start-style: none;
  }
  .close-button {
    /* in high contrast the tab title outline covers the close button outline without a z-index */
    z-index: var(--calcite-z-index);
  }
}
:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}